"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCPFCNPJ = void 0;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var Botao_1 = require("../../Botao/Botao");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var estiloTextfield = require('./InputCPFCNPJ.module.scss');
var cpfsInvalidos = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999'
];
var cnpjsInvalidos = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
];
var InputCPFCNPJ = function (_a) {
    var _b = _a.autofocus, autofocus = _b === void 0 ? false : _b, botaoDeLimpar = _a.botaoDeLimpar, conteudoDeAjuda = _a.conteudoDeAjuda, _c = _a.desabilitado, desabilitado = _c === void 0 ? false : _c, externalizarMascara = _a.externalizarMascara, id = _a.id, name = _a.name, obrigatorio = _a.obrigatorio, _d = _a.placeholder, placeholder = _d === void 0 ? 'Informe o CPF ou CNPJ aqui' : _d, _e = _a.readonly, readonly = _e === void 0 ? false : _e, _f = _a.tamanho, tamanho = _f === void 0 ? 'medium' : _f, _g = _a.titulo, titulo = _g === void 0 ? '' : _g, _h = _a.valor, valor = _h === void 0 ? '' : _h, _j = _a.validacao, validacao = _j === void 0 ? 'cpf/cnpj' : _j, validarNaEscrita = _a.validarNaEscrita, _k = _a.variante, variante = _k === void 0 ? 'regular' : _k, onChange = _a.onChange, onSubmit = _a.onSubmit;
    var _l = (0, react_1.useState)(valor || ''), inputValue = _l[0], setInputValue = _l[1];
    var _m = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _m[0], setCor = _m[1];
    var _o = (0, react_1.useState)(estiloTextfield[variante] || ''), varianteStyle = _o[0], setVarianteStyle = _o[1];
    var _p = (0, react_1.useState)(15), inputLength = _p[0], setInputLength = _p[1];
    var disabledStyle = estiloTextfield.disabled || '';
    var inputFieldSize = estiloTextfield[tamanho] || '';
    var inputfieldStyle = desabilitado ? disabledStyle : varianteStyle;
    var limparCampo = function () {
        setInputValue(null);
        onChange && onChange(null);
    };
    var handleChange = function (event) {
        //setInputValue(event.target.value);
        //onChange && onChange(event.target.value);
        var valorInput = event.target.value;
        var numero = removerMascara(valorInput);
        setInputLength(numero.length <= 11 ? 14 : 18);
        setInputValue(valorInput);
        onChange && onChange(valorInput);
        if (validarNaEscrita) {
            var isValid = handleValidation(numero);
            setVarianteStyle(isValid ? estiloTextfield.success : estiloTextfield.error);
        }
    };
    var handlePaste = function (event) {
        event.preventDefault();
        var paste = event.clipboardData.getData('text');
        var numero = removerMascara(paste);
        var valorFormatado = '';
        if (numero.length === 11) {
            valorFormatado = aplicarMascara(numero);
            setInputLength(14);
        }
        else if (numero.length === 14) {
            valorFormatado = aplicarMascara(numero);
            setInputLength(18);
        }
        else {
            valorFormatado = paste;
        }
        setInputValue(valorFormatado);
        onChange && onChange(valorFormatado);
        if (validarNaEscrita) {
            var isValid = numero.length === 11 ? validarCPF(numero) : numero.length === 14 ? validarCNPJ(numero) : false;
            setVarianteStyle(isValid ? estiloTextfield.success : estiloTextfield.error);
        }
    };
    var handleValidation = function (value) {
        var numero = removerMascara(value);
        var isValid = false;
        if (validacao === 'cpf') {
            isValid = validarCPF(numero);
        }
        else if (validacao === 'cnpj') {
            isValid = validarCNPJ(numero);
        }
        else {
            isValid = validarCPF(numero) || validarCNPJ(numero);
        }
        setVarianteStyle(isValid ? estiloTextfield.success : estiloTextfield.error);
        return isValid;
    };
    /*const aplicarMascara = (valor: string) => {
        let value = valor.replace(/\D/g, '');
        if(value.length <= 11){
            value = value.replace(/(\d{3})(\d)/, "$1.$2");
            value = value.replace(/(\d{3})(\d)/, "$1.$2");
            value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        }else{
            value = value.replace(/^(\d{2})(\d)/, "$1.$2");
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
            value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
            value = value.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return value;
    }*/
    var aplicarMascara = function (valor) {
        var value = valor.replace(/\D/g, '');
        if (value.length <= 11) {
            // Máscara CPF: 000.000.000-00
            value = value.replace(/(\d{3})(\d)/, "$1.$2");
            value = value.replace(/(\d{3})(\d)/, "$1.$2");
            value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        }
        else {
            // Máscara CNPJ: 00.000.000/0000-00
            value = value.replace(/^(\d{2})(\d)/, "$1.$2");
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
            value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
            value = value.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return value;
    };
    var removerMascara = function (valor) {
        return valor.replace(/\D/g, '');
    };
    var validarCPF = function (cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf === '') {
            return false;
        }
        else {
            if (cpf.length != 11 || cpfsInvalidos.includes(cpf)) {
                return false;
            }
            else {
                var add = 0;
                var rev = 0;
                for (var index = 0; index < 9; index++) {
                    add += parseInt(cpf.charAt(index)) * (10 - index);
                }
                rev = 11 - (add % 11);
                if (rev == 10 || rev == 11) {
                    rev = 0;
                }
                if (rev != parseInt(cpf.charAt(9))) {
                    return false;
                }
                add = 0;
                for (var index = 0; index < 10; index++) {
                    add += parseInt(cpf.charAt(index)) * (11 - index);
                }
                rev = 11 - (add % 11);
                if (rev == 10 || rev == 11) {
                    rev = 0;
                }
                ;
                if (rev != parseInt(cpf.charAt(10))) {
                    return false;
                }
                return true;
            }
        }
    };
    var validarCNPJ = function (cnpj) {
        cnpj = cnpj.replace(/\D/g, '');
        if (cnpj === '') {
            return false;
        }
        else {
            if (cnpj.length != 14 || cnpjsInvalidos.includes(cnpj)) {
                return false;
            }
            else {
                var tamanho_1 = cnpj.length - 2;
                var numeros = cnpj.substring(0, tamanho_1);
                var digitos = cnpj.substring(tamanho_1);
                var soma = 0;
                var pos = tamanho_1 - 7;
                for (var index = tamanho_1; index >= 1; index--) {
                    soma += parseInt(numeros.charAt(tamanho_1 - index)) * pos--;
                    if (pos < 2)
                        pos = 9;
                }
                var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != parseInt(digitos.charAt(0))) {
                    return false;
                }
                tamanho_1 = tamanho_1 + 1;
                numeros = cnpj.substring(0, tamanho_1);
                soma = 0;
                pos = tamanho_1 - 7;
                for (var index = tamanho_1; index >= 1; index--) {
                    soma += parseInt(numeros.charAt(tamanho_1 - index)) * pos--;
                    if (pos < 2) {
                        pos = 9;
                    }
                    ;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != parseInt(digitos.charAt(1))) {
                    return false;
                }
                return true;
            }
        }
    };
    (0, react_1.useEffect)(function () {
        setInputValue(valor);
    }, [valor]);
    (0, react_1.useEffect)(function () {
        desabilitado && setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        if (!desabilitado) {
            switch (variante) {
                case 'success':
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case 'error':
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [variante, desabilitado]);
    var BotaoLimpar = (react_1.default.createElement(Botao_1.Botao, { desabilitado: desabilitado, estilo: "ghost", onClick: function () { return limparCampo(); }, tamanho: "xsmall", tipoComportamento: "reset" },
        react_1.default.createElement(Icone_1.Icone, { nome: "close", largura: "20px", altura: "20px", desabilitado: desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var InputCPFCNPJ = (react_1.default.createElement("div", { className: "\n            ".concat(estiloTextfield.searchBar, "\n            ").concat(inputfieldStyle, "\n            ").concat(inputFieldSize, "\n        ") },
        react_1.default.createElement("input", { autoComplete: 'off', autoFocus: autofocus, className: inputFieldSize, disabled: desabilitado, inputMode: 'numeric', maxLength: inputLength, id: id, name: name, onChange: handleChange, onPaste: handlePaste, onBlur: function () {
                if (inputValue !== null) {
                    var numero = removerMascara(inputValue);
                    setInputLength(numero.length <= 11 ? 14 : 18);
                    setInputValue(aplicarMascara(numero));
                }
            }, onFocus: function () {
                if (inputValue !== null) {
                    setInputLength(validacao === 'cpf' ? 11 : 14);
                    setInputValue(removerMascara(inputValue));
                }
                else {
                    setInputLength(validacao === 'cpf' ? 11 : 14);
                }
            }, onKeyDown: function (e) {
                if (e.key === 'Enter' && inputValue !== null) {
                    var numero = removerMascara(inputValue);
                    var isValid = validacao === 'cpf'
                        ? validarCPF(numero)
                        : validacao === 'cnpj'
                            ? validarCNPJ(numero)
                            : validarCPF(numero) || validarCNPJ(numero);
                    setVarianteStyle(isValid ? estiloTextfield.success : estiloTextfield.error);
                    if (onSubmit) {
                        if (isValid && externalizarMascara) {
                            onSubmit(aplicarMascara(numero));
                        }
                        else {
                            onSubmit(isValid ? removerMascara(numero) : null);
                        }
                    }
                }
            }, placeholder: placeholder, readOnly: readonly, type: 'text', value: inputValue !== null ? inputValue : '' }),
        (botaoDeLimpar && globalMu_1.default.isNotNullOrEmpty(inputValue)) && BotaoLimpar));
    var Titulo = (react_1.default.createElement(Label_1.Label, { texto: titulo, negrito: 700, estado: variante, desabilitado: desabilitado, htmlFor: id, obrigatorio: obrigatorio }));
    var ConteudoAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || '', desabilitado: desabilitado, estado: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) || variante, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    var style = titulo || conteudoDeAjuda ? { gap: '8px' } : {};
    return (react_1.default.createElement("div", { className: estiloTextfield.container, style: style },
        titulo && Titulo,
        InputCPFCNPJ,
        conteudoDeAjuda && ConteudoAjuda));
};
exports.InputCPFCNPJ = InputCPFCNPJ;
